// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js!../../css/ANewDialog.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "#dialog-overlay.NewModuleDialog-new-dialog .dialog-container{\r\n    height: calc(100% - 35px);\r\n    width: 800px;\r\n    max-width: calc(100% - 30px);\r\n}\r\n#dialog-overlay.NewModuleDialog-new-dialog .dialog-content{\r\n    padding: 0;\r\n    height: calc(100% - 50px);\r\n}\r\n#dialog-overlay.NewModuleDialog-new-dialog .dialog-content .controls-wrapper > .controls > .row .sec-group > hr{\r\n    border-width: 2px;\r\n}", ""]);
// Exports
module.exports = exports;
